module.exports = __webpack_public_path__ + "img/x-Dm.30a967cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Dm.jpg
// module id = 6Q7J
// module chunks = 1